import http from '@/api/http.js'

export default {
  // Список уведомлений
  async getNotifications({ limit = 20, offset = 0, unread_only = false, not_closed_only = true, type = null } = {}) {
    const params = { limit, offset }
    if (unread_only) params.unread_only = true
    if (not_closed_only) params.not_closed_only = true
    if (type) params.type = type

    const res = await http.get('/notifications/', { params })
    return res.data
  },

  // Детальная информация
  async getNotification(id) {
    const res = await http.get(`/notifications/${id}/`)
    return res.data
  },

  // Пометить как прочитанное
  async markAsRead(id) {
    const res = await http.post(`/notifications/${id}/read/`)
    return res.data
  },

  // Пометить все как прочитанные
  async markAllAsRead() {
    const res = await http.post('/notifications/mark-all-read/')
    return res.data
  },

  // Закрыть уведомление
  async closeNotification(id) {
    const res = await http.post(`/notifications/${id}/close/`)
    return res.data
  },

  // Количество непрочитанных
  async getUnreadCount() {
    const res = await http.get('/notifications/unread-count/')
    return res.data
  }
}
